<div class="box-menu-settings active box-menu-settings-wrapper">
	<div class="box-menu-settings active" [class.top-padding]="isResetAnalysisWarning()">

		@if (isResetAnalysisWarning()) {
		<div data-testid="SUBSYS2_CALIBRATION_RESET_WARNING_LBL" class="alert alert-warning reset-warning">
			<i class="material-icons md-18 me-3">report_problem</i>
			{{ labels().IMAGE_GARAGE_COMPONENT_RESET_ANALYSIS_WARNING }}
		</div>
		}

		@if (form()) {
		@let f = form()!;
		<form [formGroup]="f">

			<div class="box-bordered">
				<div class="stepper pe-0">
					<div class="stepper-icon" [class.success]="f.controls.calibrationTool.valid">
						a<i class="material-icons">done</i>
					</div>
					<div data-testid="SUBSYS2_CALIBRATION_TOOL_LBL" class="stepper-label">
						{{ labels().IMAGE_CALIBRATION_COMPONENT_CALIBRATION_TOOL }}
					</div>
				</div>
				<div class="form-group pb-3 mt-3"
					[class]="{'is-valid': f.controls.calibrationTool.valid && f.controls.calibrationTool.touched, 'is-invalid': f.controls.calibrationTool.invalid && f.controls.calibrationTool.touched}">
					<div class="custom-control custom-radio custom-control-inline me-5">
						<input data-testid="SUBSYS2_CALIBRATION_TOOL_LINE_INPUT" type="radio" id="calibByLine"
							name="calibrationTool" class="custom-control-input" formControlName="calibrationTool" (change)="setLine()"
							value="line" [attr.disabled]="disabled() ? true : null"
							[class]="{'is-valid': f.controls.calibrationTool.valid && f.controls.calibrationTool.touched, 'is-invalid': f.controls.calibrationTool.invalid && f.controls.calibrationTool.touched}" />
						<label data-testid="SUBSYS2_CALIBRATION_TOOL_LINE_LBL" class="custom-control-label" for="calibByLine">
							{{ labels().IMAGE_CALIBRATION_COMPONENT_LINE }}
						</label>
					</div>
					<div class="custom-control custom-radio custom-control-inline me-5">
						<input data-testid="SUBSYS2_CALIBRATION_TOOL_CIRCLE_INPUT" type="radio" id="calibByCircle"
							name="calibrationTool" class="custom-control-input" formControlName="calibrationTool"
							(change)="setCircle()" value="circle" [attr.disabled]="disabled() ? true : null"
							[class]="{'is-valid': f.controls.calibrationTool.valid && f.controls.calibrationTool.touched, 'is-invalid': f.controls.calibrationTool.invalid && f.controls.calibrationTool.touched}" />
						<label data-testid="SUBSYS2_CALIBRATION_TOOL_CIRCLE_LBL" class="custom-control-label" for="calibByCircle">
							{{ labels().IMAGE_CALIBRATION_COMPONENT_CIRCLE }}
						</label>
					</div>
					@if (isRingsToolVisible()) {
					<div class="custom-control custom-radio custom-control-inline me-0"
						[ngbTooltip]="ringToolDisabled() ? ringToolTooltipContent : null" placement="top"
						tooltipClass="white-tooltip" container="body">
						<input data-testid="SUBSYS2_CALIBRATION_TOOL_RINGS_INPUT" type="radio" id="calibByRings"
							name="calibrationTool" class="custom-control-input" formControlName="calibrationTool"
							(change)="setRings()" value="rings" [attr.disabled]="disabled() || ringToolDisabled() ? true : null"
							[class]="{'is-valid': f.controls.calibrationTool.valid && f.controls.calibrationTool.touched, 'is-invalid': f.controls.calibrationTool.invalid && f.controls.calibrationTool.touched}" />
						<label data-testid="SUBSYS2_CALIBRATION_TOOL_RINGS_LBL" class="custom-control-label" for="calibByRings">
							{{ labels().IMAGE_CALIBRATION_COMPONENT_RINGS }}
						</label>
					</div>
					}
					@if (f.controls.calibrationTool.invalid && f.controls.calibrationTool.touched) {
					<div class="invalid-feedback d-block">
						{{ f.controls.calibrationTool | validationMsg:errorMsgs.calibrationTool | async }}
					</div>
					}
				</div>

				@if (f.value.calibrationTool) {
				<div class="d-flex justify-content-center">
					<div class="row-box clickable p-2" (click)="resetTool()" (keypress)="resetTool()">
						<i class="material-icons">sync</i>
						<span>{{ labels().IMAGE_CALIBRATION_COMPONENT_TOOL_RESET }}</span>
					</div>
				</div>
				}

			</div>

			@if (f.value.calibrationTool == 'line' || f.value.calibrationTool == 'circle') {

			<div class="box-bordered">

				<div class="stepper pe-0">
					<div class="stepper-icon" [class.success]="!isPointsRegistering">
						b<i class="material-icons">done</i>
					</div>
					<div data-testid="SUBSYS2_CALIBRATION_DRAW_TOOL_LBL" class="stepper-label">
						{{ labels().IMAGE_CALIBRATION_COMPONENT_CALIBRATION_DRAW_TOOL }}
					</div>
					<div class="box-suggestion box-suggestion-minimized" [ngbTooltip]="drawToolTooltipContent" placement="left"
						tooltipClass="suggestion-tooltip" container="body"></div>
					<!-- Suggestion draw tool tooltip -->
					<ng-template #drawToolTooltipContent>
						<div class="box-suggestion box-suggestion-minimized">
							<p data-testid="SUBSYS2_CALIBRATION_TOOLINFO_TXT"
								[innerHTML]="labels().IMAGE_CALIBRATION_COMPONENT_SUGGESTION_MESSAGE_TOOL">
							</p>
						</div>
					</ng-template>
				</div>

				<div class="wrapper-img-axis d-flex justify-content-center mt-3">
					@if (f.value.calibrationTool == 'line') {
					<img class="squared" [src]="helpImgLine" alt="line-gif">
					}
					@if (f.value.calibrationTool == 'circle') {
					<img class="squared" [src]="helpImgCircle" alt="circle-gif">
					}
				</div>

				<div class="stepper pe-0 mt-3">
					<div class="stepper-icon" [class.success]="f.controls.calibrationValue.valid">
						c<i class="material-icons">done</i>
					</div>
					<div data-testid="SUBSYS2_CALIBRATION_VALUE_LBL" class="stepper-label">
						{{ labels().IMAGE_CALIBRATION_COMPONENT_CALIBRATION_VALUE }}
					</div>
				</div>

				<div class="form-group pb-0 mt-3">
					<input data-testid="SUBSYS2_CALIBRATION_VALUE_INPUT" #calibrationInput type="number"
						class="form-control col-8" [placeholder]="labels().IMAGE_CALIBRATION_COMPONENT_CALIBRATION_VALUE"
						formControlName="calibrationValue" (keydown)="preventScientificNotation($event)"
						(input)="preventScientificNotation($event)"
						[readonly]="f.controls.calibrationTool.invalid || isPointsRegistering"
						[class]="{'is-valid': f.controls.calibrationValue.valid && f.controls.calibrationValue.touched,  'is-invalid': f.controls.calibrationValue.invalid && f.controls.calibrationValue.touched }"
						[appFormValidationMsg]="errorMsgs.calibrationValue">
				</div>
			</div>

			}

			@if (f.value.calibrationTool == 'rings') {

			<div class="box-bordered">

				<div class="stepper pe-0">
					<div class="stepper-icon" [class.success]="f.controls.proximalRing.value && f.controls.distalRing.value">
						b<i class="material-icons">done</i>
					</div>
					<div data-testid="SUBSYS2_CALIBRATION_TOOL_LBL" class="stepper-label">
						{{ labels().IMAGE_CALIBRATION_COMPONENT_CALIBRATION_RINGS }}
					</div>
					<div class="box-suggestion box-suggestion-minimized" [ngbTooltip]="selecrRingsTooltipContent" placement="left"
						tooltipClass="suggestion-tooltip" container="body"></div>
					<!-- Suggestion rings selection tooltip -->
					<ng-template #selecrRingsTooltipContent>
						<div class="box-suggestion box-suggestion-minimized">
							@if (ringCalibData()?.refType === referenceEnum.Distal) {
							<p data-testid="SUBSYS2_CALIBRATION_TOOLINFO_TXT"
								[innerHTML]="labels().IMAGE_CALIBRATION_COMPONENT_SUGGESTION_MESSAGE_RING_DIST">
							</p>
							} @else {
							<p data-testid="SUBSYS2_CALIBRATION_TOOLINFO_TXT"
								[innerHTML]="labels().IMAGE_CALIBRATION_COMPONENT_SUGGESTION_MESSAGE_RING_PROX">
							</p>
							}
						</div>
					</ng-template>
				</div>

				<div class="form-group pb-0 mt-4">
					<label data-testid="SUBSYS2_CALIBRATION_RING_PROX_LBL" for="proximalRing">
						{{ labels().IMAGE_CALIBRATION_COMPONENT_RING_PROX }}
					</label>
					<ring-selection data-testid="SUBSYS2_CALIBRATION_RING_PROX_DROPDOWN"
						[placeholder]="labels().IMAGE_CALIBRATION_COMPONENT_RING_PROX_PLACEHOLDER" [list]="ringsList()!"
						[ngModel]="initProxRing" (ngModelChange)="selectProxRing($event)" [ngModelOptions]="{standalone: true}"
						ngDefaultControl [isFoot]="ringCalibData()!.isFoot" [disabled]="disabled() || ringSelectDisabled()"
						[class.disabled]="disabled() || ringSelectDisabled()"
						[ngbTooltip]="disabled() || ringSelectDisabled() ? ringsTooltipContent : null" placement="top"
						tooltipClass="white-tooltip" container="body" />
					@if (f.controls.proximalRing.invalid && f.controls.proximalRing.touched) {
					<div class="invalid-feedback d-block">
						{{ f.controls.proximalRing | validationMsg:errorMsgs.proximalRing! | async }}
					</div>
					}
				</div>

				<div class="form-group pb-0 mt-3">
					<label data-testid="SUBSYS2_CALIBRATION_RING_DIST_LBL" for="distalRing">
						{{ labels().IMAGE_CALIBRATION_COMPONENT_RING_DIST }}
					</label>
					<ring-selection data-testid="SUBSYS2_CALIBRATION_RING_DIST_DROPDOWN"
						[placeholder]="labels().IMAGE_CALIBRATION_COMPONENT_RING_DIST_PLACEHOLDER" [list]="ringsList()!"
						[ngModel]="initDistRing" (ngModelChange)="selectDistRing($event)" [ngModelOptions]="{standalone: true}"
						ngDefaultControl [isFoot]="ringCalibData()!.isFoot" [disabled]="disabled() || ringSelectDisabled()"
						[class.disabled]="disabled() || ringSelectDisabled()"
						[ngbTooltip]="disabled() || ringSelectDisabled() ? ringsTooltipContent : null" placement="top"
						tooltipClass="white-tooltip" container="body" />
					@if (f.controls.distalRing.invalid && f.controls.distalRing.touched) {
					<div class="invalid-feedback d-block">
						{{ f.controls.distalRing | validationMsg:errorMsgs.distalRing! | async }}
					</div>
					}
				</div>

				<div class="stepper pe-0 mt-5">
					<div class="stepper-icon"
						[class.success]="f.controls.proximalRing.value && f.controls.distalRing.value &&!isPointsRegistering">
						c<i class="material-icons">done</i>
					</div>
					<div data-testid="SUBSYS2_CALIBRATION_DRAW_TOOL_LBL" class="stepper-label">
						{{
						ringCalibData()?.refType === referenceEnum.Distal ?
						labels().IMAGE_CALIBRATION_COMPONENT_CALIBRATION_DRAW_RING_DIST :
						labels().IMAGE_CALIBRATION_COMPONENT_CALIBRATION_DRAW_RING_PROX
						}}
					</div>
				</div>

				<div class="row-box wrapper-img-axis justify-content-center mt-3">
					<div>
						<img class="squared" [src]="helpImgRing" alt="rings-gif">
					</div>
				</div>

			</div>
			}

		</form>
		}

	</div>
</div>


<!-- Ring tool tooltip -->
<ng-template #ringToolTooltipContent>
	<span [innerHTML]="labels().IMAGE_CALIBRATION_COMPONENT_RING_TOOL_TOOLTIP"></span>
</ng-template>
<!-- Rings tooltip -->
<ng-template #ringsTooltipContent>
	<span [innerHTML]="labels().IMAGE_CALIBRATION_COMPONENT_RINGS_TOOLTIP"></span>
</ng-template>